<template>
  <div>
    <h1>AODA <small>Accessibility for Ontarians with Disabilities Act</small></h1>

    <p>
      The Accessibility for Ontarians with Disabilities Act (AODA) requires that all businesses in
      Ontario train their personnel (permanent and contract) in how to carry out business in a way
      that provides equal access to people with disabilities.
    </p>
    <p>
      The Employment Solution has designed this one-time training module to be quick, simple and
      practical. Under the law, our clients cannot use our (and your) services unless you have taken
      the training. Please go through this module as soon as possible to ensure that we can be fully
      compliant with the law.
    </p>
    <p style="font-size: 125%;">
      <i class="icon-download-alt"></i>
      Download our AODA Education package as either a
      <!-- eslint-disable -->
      <a href="javascript:void" @click.prevent="download('AODA Education.pps')"
        >Power Point presentation</a
      >
      or a
      <!-- eslint-disable -->
      <a href="javascript:void" @click.prevent="download('AODA Education.pdf')">PDF document</a>.
    </p>
    <p>
      After you have completed it, please enter your details in the form below and click on "I have
      completed the training" button to verify that it is complete . You will receive a confirmation
      code. This is required for all contractors working in Ontario.
    </p>
    <form>
      <section>
        <div v-if="confirmationCode">
          <p class="success-completion">
            You have successfully completed AODA, please find the confirmation code
            {{ confirmationCode }}
          </p>
        </div>
        <div class="first-last-name-row">
          <div class="form-control">
            <label>{{ $t('contractor.labels.lastName') }}<span class="asterisk">*</span></label>
            <InputField name="lastName" type="text" class="bordered" @input="onLastNameChange" />
          </div>

          <div class="form-control">
            <label>{{ $t('contractor.labels.firstName') }}<span class="asterisk">*</span></label>
            <InputField name="firstName" type="text" class="bordered" @input="onFirstNameChange" />
          </div>
        </div>
      </section>
      <TolButton
        label="I have completed the training"
        button-type="major"
        class="submit-button"
        icon-name="paper-plane"
        @click="submitAodaForm()"
      />
    </form>
    <update-modal v-if="isProcessFormBtnClicked">
      <template v-slot:modalData>
        <vue-simple-spinner size="massive" />
      </template>
    </update-modal>
  </div>
</template>
<script>
import { aodaService } from '../aoda/aoda.service';
import { AodaActions } from './aoda.keys';
import UpdateModal from '@/app/components/UpdateModal';
import InputField from '@/app/components/InputField';
import TolButton from '@/app/components/TolButton';
export default {
  components: {
    InputField,
    TolButton,
    UpdateModal
  },
  data() {
    return {
      isOnScreenDataModified: false,
      isProcessFormBtnClicked: false,
      confirmationCode: '',
      firstName: '',
      lastName: ''
    };
  },
  computed: {
    isContractor() {
      return (
        this.currentUser &&
        (this.currentUser.roles.map(r => r.role_name).some(role => role === 'Contractor') ||
          this.isSystemAdmin)
      );
    },
    isApprover() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'Client Contact')
      );
    },
    isSystemAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'System Admin')
      );
    },
    currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    download(userGuide) {
      aodaService.downloadUserGuide(userGuide);
    },
    onFirstNameChange(evt) {
      this.isOnScreenDataModified = true;
      this.firstName = evt;
    },
    onLastNameChange(evt) {
      this.isOnScreenDataModified = true;
      this.lastName = evt;
    },
    submitAodaForm() {
      this.isProcessFormBtnClicked = true;
      this.$store
        .dispatch(AodaActions.SubmitAodaForm, {
          firstName: this.firstName,
          lastName: this.lastName
        })
        .then(res => {
          this.confirmationCode = res;
          this.isProcessFormBtnClicked = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors';

.first-last-name-row {
  display: flex;
  flex-direction: row;
  margin-top: 3%;
  > div {
    display: flex;
    flex-direction: row;
    > label {
      margin: 2%;
    }
  }
}
section {
  margin-bottom: 3%;
}
.success-completion {
  font-weight: bold;
}
</style>
